import { MijnRoute } from '../../../mijn-navigatie.model';

export const AI_CONSENT: MijnRoute = {
    path: 'toestemming-inzicht-in-je-geld',
    navigationEvent: 'toAiConsent',
    regex: /^\/zelf-regelen\/privacy\/toestemming-inzicht-in-je-geld$/,
    webcomponent: 'mijn-ai-consent-webcomponent'
};
